import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=29cef96a&scoped=true&"
import script from "./Drag.vue?vue&type=script&lang=js&"
export * from "./Drag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cef96a",
  null
  
)

export default component.exports